<template>
  <div>
    <div v-if="this.localModel.edittype == 'tag'" class="gm-edit-detail-assignments">
      <div class="step3 mb-6">
        <div class="activeicon">
          <p class="font-semibold text-base text-dark mb-2">
            {{ $t('frontend_groovemail_sequences_edit_tags') }}
          </p>
        </div>
        <div class="flex border-grey-300">
          <div class="w-full flex flex-nowrap flex-col">
            <div class="w-full mb-2 relative">
              <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
              <select
                v-model="localModel.category"
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                @change="onChangecategory($event)"
              >
                <option value>
                  {{$t('frontend_groovemail_sequences_edit_select_category') }}
                </option>
                <option
                  v-for="category in categories"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ category.name }}
                </option>
              </select>
            </div>
            <div class="w-full relative">
              <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
              <select
                v-model="assignrecipient"
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                @change="changerecipient($event)"
              >
                <option value>
                  {{ $t('frontend_groovemail_sequences_select_tag') }} ..
                </option>
                <option
                  v-for="(tag, index) in this.tags"
                  :key="index"
                  :value="tag.id"
                  :data-name="tag.name"
                >
                  {{ tag.name }}
                </option>
              </select>
            </div>
            <div
              class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2 gm-edit-detail-assignments__create"
              @click="createNewTag"
            >
              <PlusIcon class="h-5 w-5"/>
              <p>{{ $t('frontend_groovemail_contacts_step4_create_newtag') }}</p>
            </div>
            <div class="w-full">
              <div class="text-center w-full flex flex-row flex-wrap">
                <p
                  v-for="(option, index) in localModel.editassigned"
                  :key="index"
                  class="list-chip font-thin leading-8 border-lg text-primary-invert bg-primary mt-2 mr-2 relative"
                >
                  <span class="text-xs pl-2 pr-2 font-semibold">{{
                    option.name
                  }}</span>
                  <span class="px-2" @click="deletemodule(option)">
                    <span style="cursor: pointer" class="fa text-xs cross-chip"
                      >&#xf00d;</span
                    >
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.localModel.edittype == 'list'" class="gm-edit-detail-assignments">
      <div class="step1 mb-6">
        <div class="w-full text-left activeicon">
          <p class="font-semibold text-base text-dark mb-2">
            {{ $t('frontend_groovemail_sequences_lists') }}
          </p>
        </div>
        <div class="flex border-grey-300 mt-2">
          <div class="w-full flex flex-nowrap flex-col">
            <div class="w-full relative">
              <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
              <select
                v-model="assignrecipient"
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                @change="changerecipient($event)"
              >
                <option value="">{{ $t('frontend_select') }}</option>
                <option
                  v-for="(list, index) in this.lists"
                  :key="index"
                  :value="list.id"
                  :data-name="list.name"
                >
                  {{ list.name }}
                </option>
              </select>
            </div>
            <div
              class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2 gm-edit-detail-assignments__create"
              @click="createNewList"
            >
              <PlusIcon class="h-5 w-5"/>
              <p>{{ $t('frontend_groovemail_contacts_step4_create_new_list') }}</p>
            </div>
            <div class="w-full">
              <div class="text-center w-full flex flex-row flex-wrap">
                <p
                  v-for="(option, index) in localModel.editassigned"
                  :key="index"
                  class="list-chip font-thin leading-8 border-lg text-primary-invert bg-primary mt-2 mr-2 relative"
                >
                  <span class="text-xs font-semibold pl-2 pr-2">{{
                    option.name
                  }}</span>
                  <span class="px-2" @click="deletemodule(option)">
                    <span style="cursor: pointer" class="fa text-xs cross-chip"
                      >&#xf00d;</span
                    >
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.localModel.edittype == 'goto'">
      <div class="step3 mb-6">
        <div class="activeicon">
          <p class="font-semibold text-base text-dark mb-2">
            {{ $t('frontend_groovemail_sequences_edit_options') }}
          </p>
        </div>
        <div class="flex flex-nowrap flex-col">
          <div class="w-full option-div">
            <p class="font-semibold text-base text-dark mb-2">
              {{ $t('frontend_groovemail_sequences_edit_redirect') }} :
            </p>
            <select
              :disabled="true"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option>{{ this.localModel.currentflowname }}</option>
            </select>
            <div class="goto-sel relative">
              <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
              <select
                v-model="localModel.editassigned[0].step"
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
              >
                <option value="">
                  {{ $t('frontend_groovemail_sequences_edit_select_step') }} ..
                </option>
                <option
                  v-for="node in Object.keys(nodesPresent)"
                  :key="nodesPresent[node].id"
                  :value="nodesPresent[node].id"
                >
                  {{ nodesPresent[node].id }} - {{ nodesPresent[node].name }}
                </option>
              </select>
            </div>
            <div class="goto-sel relative">
              <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
              <select
                v-model="localModel.editassigned[0].flow"
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
              >
                <option value="">
                  {{ $t('frontend_groovemail_sequences_edit_select_flow') }} ..
                </option>
                <option
                  v-for="(flow, index) in flowSetting"
                  :key="index"
                  :value="flow.id"
                >
                  {{ flow.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.localModel.edittype == 'split'" class="split-node gm-edit-detail-assignments">
      <div class="step5 mb-6">
        <div class="w-full text-left activeicon">
          <p class="font-semibold text-base text-dark mb-2">
            {{ $t('frontend_groovemail_sequences_edit_split_conditions') }} *
          </p>
          <div>
            <div class="flex flex-col mt-2">
              <div
                class="w-full relative"
                :class="{
                  'cursor-not-allowed':
                    localModel.editassigned &&
                    localModel.editassigned.length > 0,
                }"
              >
                <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                <select
                  v-model="mainselect"
                  :disabled="
                    localModel.editassigned &&
                    localModel.editassigned.length > 0
                  "
                  :class="{
                    'pointer-events-none':
                      localModel.editassigned &&
                      localModel.editassigned.length > 0,
                  }"
                  class="w-full h-10 rounded-lg text-sm bg-white border border-grey-200 text-dark pl-3 pr-7 appearance-none"
                  @change="changeSelect($event)"
                >
                  <option value>{{ $t('frontend_select') }}</option>
                  <option value="list" data-name="Subscribed to list">
                    {{ $t('frontend_groovemail_segment_subscribed_to_list') }}
                  </option>
                  <option value="list" data-name="Not subscribed to list">
                    {{
                      $t('frontend_groovemail_segment_not_subscribed_to_list')
                    }}
                  </option>
                  <option value="tag" data-name="Has tag">
                    {{ $t('frontend_groovemail_segment_subscribe_hastag') }}
                  </option>
                  <option value="tag" data-name="Does not have tag">
                    {{ $t('frontend_groovemail_segment_subscribe_doesnot') }}
                  </option>
                </select>
              </div>
              <div
                v-if="this.mainselect == 'list'"
                class="w-full mt-2 relative"
              >
                <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                <select
                  v-model="assignrecipient"
                  class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                  @change="changesplitrecipient($event)"
                >
                  <option value>{{ $t('frontend_select') }}</option>
                  <option
                    v-for="(list, index) in this.lists"
                    :key="index"
                    :value="list.id"
                    :data-name="list.name"
                  >
                    {{ list.name }}
                  </option>
                </select>
              </div>

              <div v-if="this.mainselect == 'tag'" class="w-full mt-2 relative">
                <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                <select
                  v-model="localModel.category"
                  class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                  @change="onChangecategory($event)"
                >
                  <option value>
                    {{
                      $t('frontend_groovemail_sequences_edit_select_category')
                    }}
                  </option>
                  <option
                    v-for="(category, index) in this.categories"
                    :key="index"
                    :value="category.id"
                    :data-name="category.name"
                  >
                    {{ category.name }}
                  </option>
                </select>
              </div>

              <div v-if="this.mainselect == 'tag'" class="w-full mt-2 relative">
                <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                <select
                  v-model="assignrecipient"
                  class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                  @change="changesplitrecipient($event)"
                >
                  <option value>
                    {{ $t('frontend_groovemail_sequences_edit_select_tag') }}
                  </option>
                  <option
                    v-for="(tag, index) in this.tags"
                    :key="index"
                    :value="tag.id"
                    :data-name="tag.name"
                  >
                    {{ tag.name }}
                  </option>
                </select>
              </div>

              <div class="w-full">
                <div class="text-center w-full flex flex-row flex-wrap">
                  <p
                    v-for="(option, index) in localModel.editassigned"
                    :key="index"
                    class="list-chip font-thin leading-8 border-lg text-primary-invert bg-primary mt-2 mr-2 relative"
                  >
                    <span
                      class="text-xs font-semibold pl-2 pr-2"
                      >{{ option.main + ' ' + option.name }}</span
                    >
                    <span class="px-2" @click="deletemodule(option)">
                      <span
                        style="cursor: pointer"
                        class="fa text-xs cross-chip"
                        >&#xf00d;</span
                      >
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.localModel.edittype == 'delay'">
      <DelayNode
        :model="model"
        @updateModel="model = $event"
      ></DelayNode>
    </div>

    <div v-if="this.localModel.edittype == 'email'" class="email-node">
      <div class="mb-6">
        <gd-tabs
          :tabs="tabs"
          :currentTab="currentEmailTab"
          :wrapper-class="'gs-default-tabs'"
          :tab-class="mainTabClass"
          :tab-active-class="'p-2 border-primary border-b-2 text-primary gs-default-tabs-item-active'"
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleEmailTabChange"
        />
      </div>
      <div class="step3 mb-6" v-if="currentEmailTab === 'settings'">
        <div class="flex flex-no-wrap flex-col">
          <div class="flex flex-col w-full">
            <label class="font-semibold text-base text-dark mb-2">
              {{ $t('frontend_groovemail_adminsetting_name') }}
            </label>
            <text-input
              class="broadCast-name"
              variant="base"
              v-model="localModel.broadcast"
              :placeholder="$t('frontend_groovemail_adminsetting_name')"
              :validator="$v.localModel.broadcast"
            />
          </div>
        </div>
      </div>
      <!-- end 3rd step -->
      <div class="step4 mb-6" v-if="currentEmailTab === 'settings'">
        <div class="flex flex-no-wrap w-full flex-col">
          <label class="font-semibold text-base text-dark mb-2">
            {{ $t('frontend_groovemail_campains_step2_sender') }}
          </label>
          <div class="w-full relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <!-- @change="updatedEmailSender()" -->
            <select
              v-model="localModel.sender_id"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value="-1">
                {{ $t('frontend_groovemail_segment_select') }} ..
              </option>
              <option
                v-for="(sender, index) in this.senders"
                :key="index"
                :value="sender.id"
                :data-name="sender.name"
              >
                {{ sender.name }}
              </option>
            </select>
          </div>

          <!-- Can mail/Upgraded user/Sandbox mode check -->
          <div
            v-if="this.userCanMail"
            class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2"
            @click="createNewEmailSender"
          >
            <PlusIcon class="h-5 w-5"/>
            <p>
              {{ $t('frontend_create') }}
              {{ $t('frontend_groovemail_settings_sender_settings') }}
            </p>
          </div>
          <!-- Can mail/Upgraded user/Sandbox mode check -->
        </div>
      </div>

      <div class="step7 mb-6">
        <div class="activeicon">
          <div class="flex flex-col">
            <div class="flex mb-6" v-if="currentEmailTab === 'settings'">
              <div class="w-full">
                <div>
                  <div class="w-full mb-2">
                    <label
                      class="flex items-center font-semibold text-base text-dark mb-2"
                    >
                      <span class="mr-1">{{
                        $t('frontend_groovemail_sequences_edit_subject')
                      }}</span>
                      <button
                        v-tooltip="{
                          content: $t(
                            'frontend_add_dynamic_variables_to_subject'
                          ),
                          placement: 'right-start',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          offset: 10,
                          delay: {
                            show: 200,
                            hide: 300,
                          },
                        }"
                      >
                        <InfoIcon class="text-grey-600 h-4 w-4"/>
                      </button>
                    </label>
                  </div>

                  <div class="w-full relative">
                    <text-input
                      class="broadCast-name"
                      variant="base"
                      v-model="localModel.subject"
                      :placeholder="$t('frontend_groovemail_sequences_edit_subject')"
                      :validator="$v.localModel.subject"
                    />
                    <div
                      v-click-outside="closeSubjectVariables"
                      class="plus-round-icon bg-primary absolute"
                      style="right: 8px; top: 8px"
                      @click="openSubjectVariables"
                    >
                      <div
                        class="bg-white btn-radius py-6 pl-6 absolute overflow-auto"
                        style="
                          width: 290px;
                          right: -10px;
                          bottom: 35px;
                          z-index: 100;
                          box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
                        "
                        v-if="showSubjectDropdown"
                      >
                        <div class="pr-6">
                          <text-input
                            variant="base"
                            v-model="emailSubjectVariableSearch"
                            @input="changedEmailSubjectSearchVariable"
                            :placeholder="$t('frontend_groovemail_tables_search_query')"
                          >
                            <SearchIcon slot="prependIcon"/>
                          </text-input>
                        </div>
                        <VuePerfectScrollbar>
                          <div
                            class="mt-6 text-sm font-semibold"
                            style="max-height: 160px"
                          >
                            <div
                              class="mb-6"
                              v-for="(
                                option, index
                              ) in dynamic_variables_sms_content_subject"
                              :key="index"
                            >
                              <div
                                class="cursor-pointer text-grey-700 text-left"
                                @click="copyVariableInSubject(option)"
                              >
                                {{ option.label }}
                              </div>
                            </div>
                          </div>
                        </VuePerfectScrollbar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex" v-if="currentEmailTab === 'settings'">
              <div class="w-full">
                <div>
                  <div class="w-full">
                    <label class="font-semibold text-base text-dark mb-2">
                      {{ $t('frontend_groovemail_sequences_edit_preview') }}
                    </label>
                  </div>
                  <div class="w-full">
                    <text-input
                      class="broadCast-name"
                      variant="base"
                      v-model="localModel.previewtext"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="currentEmailTab === 'message'">
              <div class="flex flex-col my-6">
                <label class="font-semibold text-base mb-2">
                  {{ $t('frontend_groovemail_email_types_label') }}
                </label>
                <div class="flex">
                  <div
                    v-for="(option, index) in email_type_options"
                    :key="index"
                    class="w-1/3 campaign-radio"
                    :class="{ 'pl-2': index !== 0, 'pr-2': index !== email_type_options.length - 1 }"
                  >
                    <gd-custom-radio
                      v-model="localModel.editor_type"
                      class="bg-white border p-4 text-center"
                      :option="option"
                      value="localModel.editor_type"
                    ></gd-custom-radio>
                  </div>
                </div>
              </div>

              <div>
                <div v-if="localModel.editor_type === 3 && showEmailComposers">
                  <div class="mb-2">
                    <label class="font-semibold text-base">
                      {{ $t('frontend_groovemail_campain_message') }}
                    </label>
                  </div>
                  <div class="mb-2" style="width: 400px" v-if="this.localModel.template_name">
                    <label class="font-semibold text-base">
                      {{ $t('frontend_groovemail_email_builder_past_template_email_name') }} : {{ this.localModel.template_name }}
                    </label>
                  </div>
                  <div class="flex justify-between">
                    <gd-button
                      size="expand"
                      variant="primary"
                      @click="openEmailBuilder"
                      >{{
                        $t(
                          'frontend_groovemail_email_builder_edit_your_email_placeholder'
                        )
                      }}</gd-button
                    >
                    <gd-button
                      size="md"
                      class="ml-4"
                      :class="{
                        'cursor-not-allowed disabled-preview': !localModel.content,
                      }"
                      @click="localModel.content ? openEditEmailPreview() : null"
                    >
                      <PreviewIcon class="h-5 w-5"/>
                    </gd-button>
                  </div>
                </div>
                <div v-if="localModel.editor_type !== 3 && showEmailComposers">
                  <email-basic-editor
                    :key="1"
                    ref="sequence-edit-email-editor"
                    :editorOptions="sequenceEditorOptions"
                    :editorContent="localModel.content"
                    :editorNodeWithNoMargin="true"
                    :editorWithBlockedLinkRestriction="true"
                    :editorDynamicVariables="builderVariables"
                    openedFrom="sequence-edit"
                    :allowEditorPreview="true"
                    :allowEditorHtmlView="false"
                    :currentEditorView="localModel.editor_type"
                    @editorContentUpdated="localModel.content = $event"
                  ></email-basic-editor>
                </div>

                <div
                  class="text-left pt-4"
                  v-if="checkValidEmailContent() && isEmailContentSubmitted"
                >
                  <p class="text-sm text-danger">
                    {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_email_content_empty') }}
                  </p>
                </div>
              </div>
              <div class="mt-4">
                <SendTestEmail
                  ref="sendEditSeqTestMail"
                  @showLoader="showLoader"
                  @hideLoader="hideLoader"
                  @proceeedSendingTestEmail="proceeedSendingTestEmail"
                ></SendTestEmail>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end step 7 -->
    </div>

    <div v-if="this.localModel.edittype == 'sms'" class="sms-node">
      <div class="mb-6">
        <gd-tabs
          :tabs="Tabs"
          :currentTab="currentSmsTab"
          :wrapper-class="'gs-default-tabs'"
          :tab-class="mainTabClass"
          :tab-active-class="'p-2 border-primary border-b-2 text-primary gs-default-tabs-item-active'"
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleSmsTabChange"
        />
      </div>
      <div class="step3 mb-6" v-if="currentSmsTab === 'settings'">
        <div class="flex flex-no-wrap flex-col">
          <div class="flex flex-col w-full">
            <label class="font-semibold text-base text-dark mb-2">
              {{ $t('frontend_groovemail_adminsetting_name') }}
            </label>
            <text-input
              class="broadCast-name"
              variant="base"
              v-model="localModel.broadcast"
              :placeholder="$t('frontend_groovemail_adminsetting_name')"
              :validator="$v.localModel.broadcast"
            />
          </div>
        </div>
      </div>
      <!-- start step 4 -->
      <div class="step4 mb-6" v-if="currentSmsTab === 'settings'">
        <div class="flex flex-no-wrap flex-col">
          <label class="font-semibold text-base text-dark mb-2">
            {{ $t('frontend_groovemail_campains_step2_sender') }}
          </label>
          <div class="w-full">
            <div class="relative">
              <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
              <select
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                v-model="localModel.sender_id"
                value="localModel.sender_id"
                @change="setSmsSender(localModel.sender_id)"
              ><option :value="-1">{{$t('frontend_groovemail_sequences_email_select_sender') }}
                </option>
                <option
                  v-for="sender in this.smsSenders"
                  :value="sender.id"
                  :key="sender.id"
                  :data-name="sender.gateway_name"
                >
                  {{ sender.gateway_name }}
                </option>
              </select>
            </div>
            <div
              class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2"
              @click="createNewSmsSender"
            >
              <PlusIcon class="h-5 w-5"/>
              <p>
                {{ $t('frontend_create') }}
                {{ $t('frontend_groovemail_campaigns_sms_sender_label') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- end step 4 -->

      <!-- start step 7 -->
      <div class="step7 mb-6" v-if="currentSmsTab === 'message'">
        <div class="activeicon">
          <div class="w-full relative">
            <div class="flex justify-end mb-4">
              <div class="text-sm text-grey-700 mr-2">
                {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_insert_varaibles') }}
              </div>
              <div
                v-click-outside="closeSmsVariables"
                class="plus-round-icon"
                @click="openSmsVariables"
              >
                <div
                  class="bg-white btn-radius py-6 pl-6 absolute z-10 overflow-auto"
                  style="
                    width: 200px;
                    right: 0;
                    top: 35px;
                    box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
                  "
                  v-if="showSmsVariableDropdown"
                >
                  <div class="pr-6">
                    <text-input
                      variant="base"
                      v-model="smsVariableSearch"
                      @input="changedSmsSearchVariable"
                      :placeholder="$t('frontend_groovemail_tables_search_query')"
                    >
                      <SearchIcon slot="prependIcon"/>
                    </text-input>
                  </div>
                  <VuePerfectScrollbar>
                    <div
                      class="mt-6 text-sm font-semibold"
                      style="max-height: 180px"
                    >
                      <div
                        class="mb-6"
                        v-for="(
                          option, index
                        ) in dynamic_variables_sms_content_subject"
                        :key="index"
                      >
                        <div
                          class="cursor-pointer text-grey-700 text-left"
                          @click="copySmsVariable(option)"
                        >
                          {{ option.label }}
                        </div>
                      </div>
                    </div>
                  </VuePerfectScrollbar>
                </div>
              </div>
            </div>
            <text-area
              class="h-56 "
              variant="base"
              id="sms-text-area"
              v-model="localModel.smsContent"
              :placeholder="$t('frontend_groovemail_campaigns_create_broadcast_enter_sms_content')"
              :validator="$v.localModel.smsContent"
            />
          </div>
          <div class="text-left pt-4" v-if="!this.localModel.smsContent">
            <p class="text-sm text-danger">
              {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_sms_content_empty') }}
            </p>
          </div>
        </div>
      </div>
      <!-- end step 7 -->
    </div>

    <div v-if="this.localModel.edittype == 'postal'">
      <div class="flex mb-6 text-center">
        <p class="text-sm">
          <span>{{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_campaign_content_sub_heading_part_a') }}</span>
          <span
            class="
              cursor-pointer
              text-primary
              font-bold
            "
            @click="redirectToCLosemSignupPage"
          >
            closem.ai
          </span>
          <span>
            {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_campaign_content_sub_heading_part_b') }}
          </span>
          <span
            class="
              cursor-pointer
              font-bold text-primary
            "
            @click="redirectToCLosemDashboard"
          >
            {{ $t('frontend_groovemail_campaigns_create_postal_integration_postal_click_here_to_create_postals') }}
          </span>
        </p>
      </div>
      <div class="step1 mb-6">
        <div class="activeicon mb-2">
          <p class="font-semibold text-base text-dark">
            {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_postal_content_label') }}
          </p>
        </div>
        <div class="flex border-grey-300 mt-2">
          <div class="w-full flex flex-nowrap flex-col">
            <div class="w-full relative">
              <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
              <select
                @change="onPostalCampaignChange($event)"
                v-model="localModel.postalSequenceId"
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
              >
                <option value disabled>
                  {{ $t('frontend_select') }}
                </option>
                <option
                  v-for="(campaign, index) in postalCampaigns"
                  :data-name="campaign.title"
                  :key="index"
                  :value="campaign.id"
                >
                  {{ campaign.title }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Email builder modal -->
    <portal to="modalsTarget">
      <slide-over
        id="generic-email-builder-modal"
        bgColor="white"
        width="full"
        animation="slideup"
        name="generic-email-builder-modal-sequence-edit"
        @collapse="openEmailChangeLostConfirm('email')"
      >
        <email-builder
          ref="sequence-edit-email-builder"
          :emailTemplateId="emailTemplateId"
          :templateId="template_id"
          :emailMeta="getEmailMetaData"
          :openedFrom="'sequence'"
          :openedType="localModel.email_id ? 'edit' : 'add'"
          :templateType="templateType"
          :builderVariables="builderVariables"
          :blockedLinkRestriction="true"
          :showResetTemplate="true"
          :allowSaveRows="true"
          @saveEmailTemplateContent="saveContentWithMeta"
          @changeCurrentTemplate="openEmailChangeLostConfirm('template')"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
        ></email-builder>
      </slide-over>

      <gd-modal
        id="show-emailpreview-modal"
        width="80%"
        height="100%"
        name="open-sequence-edit-preview-modal"
        :title="$t('frontend_preview')"
      >
        <VuePerfectScrollbar>
          <div class="w-full p-6" style="height: calc(100vh - 115px); min-height: 70vh">
            <div>
              <div
                class="pb-6"
                v-html="
                  localModel.content +
                  `<p style='margin: 0px'><br></p>` +
                  unsubscribeContent
                "
              ></div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </gd-modal>

      <gd-modal
        name="edit-sequence-email-templates-modal"
        class="gm-befree-email-templates-modal"
        :title="$t('frontend_groovemail_modal_email_template_header')"
        width="95vw"
        height="95vh"
      >
        <div
          class="w-full py-4"
          style="max-height: calc(100vh - 90px); min-height: 70vh"
        >
          <template-container
            filtersHeight="calc(100vh - 260px)"
            templatesHeight="calc(100vh - 120px)"
            @showLoader="showLoader"
            @hideLoader="hideLoader"
            @selectedTemplate="selectThisTemplate"
          ></template-container>
        </div>
      </gd-modal>


      <!-- Confirmation email change lost modal -->
      <confirm-modal
        :ref="`confirmation-email-change-lost`"
        :name="`confirmation-email-change-lost`"
        :buttonText="$t('frontend_confirm')"
        :cancelText="$t('frontend_cancel')"
        :hideClose="true"
        :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
        :messageContent="confirmMessage"
        @confirm="emailChangeLostConfirm"
      />
    </portal>

    <!-- Confirmation editor type change modal -->
    <confirm-modal
      :ref="`confirmation-editor-type`"
      :name="`confirmation-editor-type`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :hideClose="true"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_email_type_change_warning')"
      @confirm="confirmEditorTypeChange"
      @close="closeConfirmEditorTypeChange"
    />
  </div>
</template>

<script>
import axios from 'axios';
import auth from '@groovepages/gd-lib/auth';
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ClickOutside from 'vue-click-outside';
import EmailBuilder from '@/components/befree-email-builder/builder';
import DelayNode from './DelayNode';
import EmailBasicEditor from '@/components/EmailBasicEditor';
import { syncEditorContent } from '@/components/emailContentValidation';
import TemplateContainer from '@/components/befree-email-builder/template-container';
import SlideOver from '@/components/SlideOver';
import SendTestEmail from '@/components/send-test-email';
import Category from '@/models/Category';
import showAlert from '@/components/sweet-alert-popup.js';
import themeConfig from '@/theme/themeConfig';

// import icons
import InfoIcon from '@/assets/images/icons/new/info_new.svg';
import PreviewIcon from '@/assets/images/icons/new/preview_new.svg';
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import DownIcon from '@/assets/images/icons/new/down_new.svg';
import SearchIcon from '@/assets/images/icons/new/search_new.svg';

export default {
  name: 'EditDetail',
  props: {
    model: {
      required: true,
    },
  },

  directives: {
    ClickOutside,
  },

  data() {
    return {
      isEmailContentSubmitted: false,
      editorTypeChangedInternally: false,
      showEmailComposers: true,
      currentSmsTab: 'settings',
      currentEmailTab: 'settings',
      verifiedSendersRequired: false,
      showSection: {
        type: 1,
      },
      currentSmsSender: '',
      localModel: this.model,
      postalCampaigns: [],
      addbtndisabled: true,
      tagname: '',
      listname: '',
      segmentname: '',
      lists: [],
      tags: [],
      smsSenders: [],
      senders: [],
      categories: [],
      nodesPresent: [],
      mainselect: '',
      mainselectname: '',
      assignrecipient: '',
      assignrecipientname: '',
      operation: '',
      tagdisabled: true,
      listdisabled: false,
      segmentdisabled: false,
      showSmsVariableDropdown: false,
      smsVariableSearch: '',
      showSubjectDropdown: false,
      emailSubjectVariableSearch: '',
      unsubscribeContent: '',
      dynamic_variables_sms_content_subject: [],
      dynamic_variables_sms_subject: [
        {
          label: this.$t('frontend_groovemail_contacts_step2_first_name'),
          value: '{first_name}',
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_last_name'),
          value: '{last_name}',
        },
        {
          label: this.$t('frontend_groovemail_email_show_email'),
          value: '{email}',
        },
        {
          label: this.$t('frontend_groovemail_email_show_phone'),
          value: '{phone_number}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_company'),
          value: '{company}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          value: '{address_1}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          value: '{address_2}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_city'),
          value: '{city}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_state'),
          value: '{state}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_country'),
          value: '{country}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          value: '{zip}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_url'),
          value: '{url}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          value: '{tax_number}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_billing'),
          value: '{billing_address}',
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          value: '{ip_address}',
        },
      ],
      builderVariables: [
        {
          name: this.$t('frontend_groovemail_contacts_step2_first_name'),
          label: this.$t('frontend_groovemail_contacts_step2_first_name'),
          value: '{first_name}',
        },
        {
          name: this.$t('frontend_groovemail_contacts_step2_last_name'),
          label: this.$t('frontend_groovemail_contacts_step2_last_name'),
          value: '{last_name}',
        },
        {
          name: this.$t('frontend_groovemail_email_show_email'),
          label: this.$t('frontend_groovemail_email_show_email'),
          value: '{email}',
        },
        {
          name: this.$t('frontend_groovemail_email_show_phone'),
          label: this.$t('frontend_groovemail_email_show_phone'),
          value: '{phone_number}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_company'),
          label: this.$t('frontend_groovemail_mail_lead_index_company'),
          value: '{company}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          label: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          value: '{address_1}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          label: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          value: '{address_2}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_city'),
          label: this.$t('frontend_groovemail_mail_lead_index_city'),
          value: '{city}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_state'),
          label: this.$t('frontend_groovemail_mail_lead_index_state'),
          value: '{state}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_country'),
          label: this.$t('frontend_groovemail_mail_lead_index_country'),
          value: '{country}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          label: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          value: '{zip}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_url'),
          label: this.$t('frontend_groovemail_mail_lead_index_url'),
          value: '{url}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          label: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          value: '{tax_number}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_billing'),
          label: this.$t('frontend_groovemail_mail_lead_index_billing'),
          value: '{billing_address}',
        },
        {
          name: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          label: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          value: '{ip_address}',
        },
      ],
      sequenceEditorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              [{ list: 'ordered' }, { list: 'bullet' }],

              ['link', 'image'],
              [{ size: ['10px', false, '18px', '32px'] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ align: [] }],
            ],
            handlers: {
              image: () => this.handleImageInsertionInContent()
            }
          },
        },
      },
      emailTemplateId: '',
      templateType: '',
      template_id: null,

      newEmailType: null,
      oldEmailType: null,
      confirmMessage: '',
      confirmTarget: '',
    };
  },

  validations: {
    localModel: {
      broadcast: {
        required,
      },
      subject: {
        required,
      },
      content: {
        required,
      },
      smsContent: {
        required,
      },
    },
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },

    'localModel.editor_type': async function handleEmailTypeChange(newEmailType, oldEmailType) {
      if (this.editorTypeChangedInternally) {
        this.editorTypeChangedInternally = false;
      } else if (
        (((newEmailType === 1 || newEmailType === 2) && oldEmailType === 3) ||
          newEmailType === 3) && this.localModel.content
      ) {
        this.showEmailComposers = false;

        // open confirmation editor type
        this.openEditorTypeConfirmation(newEmailType, oldEmailType);
      } else if (newEmailType === 2 && oldEmailType === 1) {
        this.validateEmailContent();
      }
    },
  },

  async created() {
    this.showLoader();

    try {
      await this.fetchCustomFieldVariable();
      if (this.localModel.edittype === 'email') {
        await this.fetchSendersData();
        await this.fetchsenders();
        if (this.localModel.email_id) {
          this.emailTemplateId = this.localModel.email_id;
          this.templateType = 'user-email';
        }
        this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
      } else if (this.localModel.edittype === 'sms') {
        await this.fetchSendersData();
        await this.fetchSmsSenders();
        this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
      } else if (this.localModel.edittype === 'tag') {
        this.categories = await Category.$get();
      } else if (this.localModel.edittype === 'list') {
        const mailLists = await axios.get(`/maillistonly`);
        this.lists = mailLists?.data?.data;
      } else if (this.localModel.edittype === 'split') {
        this.categories = await Category.$get();
        const mailLists = await axios.get(`/maillistonly`);
        this.lists = mailLists?.data?.data;
      } else if (this.localModel.edittype === 'postal') {
        this.$emit('showLoader');
        await this.fetchPostalCampaigns();
        this.$emit('hideLoader');
      }
      // await this.updatedEmailSender();

      this.hideLoader();
    } catch (error) {
      this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
    }
  },

  mounted() {
    let reteNodes;
    if (this.localModel.retedata.nodes) {
      reteNodes = this.localModel.retedata.nodes;
    }
    if (reteNodes) {
      Object.keys(reteNodes).forEach((ele) => {
        if (reteNodes[ele].name === 'Goto') {
          delete reteNodes[ele];
        }
      });
    }
    this.nodesPresent = reteNodes;
  },

  methods: {
    // Can mail/Upgraded user/Sandbox mode check
    ...mapGetters('mailing', ['getCanMail']),
    // Can mail/Upgraded user/Sandbox mode check

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    // open emailChangeLostConfirm modal
    openEmailChangeLostConfirm(option) {
      // set the confirmTarget
      this.confirmTarget = option;

      if (option === 'email') {

        // check change in content of email builder
        const changeInContent = this.$refs['sequence-edit-email-builder'].checkChangeInContent();
        if (changeInContent) {
          // set the confirmMessage and confirmTarget
          this.confirmMessage = this.$t('frontend_groovemail_email_builder_content_will_be_lost');

          // open confirmation email chnage lost modal
          this.$refs[`confirmation-email-change-lost`].open();
        } else {
          this.closeBefreeBuilderSlider();
        }
        this.template_id = null;
      } else if (option === 'template') {
        this.confirmMessage = this.$t('frontend_groovemail_befree_email_builder_change_template_warning');

        // open confirmation chnage tamplate lost data modal
        this.$refs[`confirmation-email-change-lost`].open();
      }
    },

      // confirm email chnage lost modal
      async emailChangeLostConfirm() {
      if(this.confirmTarget === 'email') {
        this.closeBefreeBuilderSlider();

        this.template_id = null;
      } else if (this.confirmTarget === 'template') {
        this.closeBefreeBuilderSlider();
        this.initializeEmailContentData();

        // if (this.localModel.email_id) {
        //   this.initializeEmailContentData();
        //   // this.$emit('saveOnEmailContentReset'); // save after reset
        // } else {
        //   this.initializeEmailContentData();
        // }

        this.$root.$emit('modal-open', 'edit-sequence-email-templates-modal');
      }

      // reset the confirmMessage and confirmTarget
      this.confirmTarget = '';
      this.confirmMessage = '';
    },

    openBefreeBuilderSlider() {
      this.$root.$emit('expand-slider', 'generic-email-builder-modal-sequence-edit');
    },

    closeBefreeBuilderSlider() {
      this.$root.$emit('collapse-slider', 'generic-email-builder-modal-sequence-edit');
    },

    handleImageInsertionInContent() {
      this.$refs['sequence-edit-email-editor'].handleImageInsertionInContent();
    },

    checkValidEmailContent() {
      let validEmailContent = false;
      if (this.localModel.editor_type === 1 || this.localModel.editor_type === 2) {
        if (this.localModel.content) {
          validEmailContent = true;
        }
      } else if (
        this.localModel.content || this.localModel.emailContentSections
      ) {
        validEmailContent = true;
      }
      return !validEmailContent;
    },

    validateEmailContent() {
      const editor = this.$refs ? this.$refs['sequence-edit-email-editor'] : null;
      syncEditorContent(editor, (html) => {
        this.localModel.content = html;
      });
    },

    async openEditEmailPreview() {
      this.showLoader();
      try {
        const unsubscribeData = await axios.get('/setting/get-unsubscribe-layout');
        this.unsubscribeContent = unsubscribeData.data.footer_layout;

        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);

        return;
      }

      this.$root.$emit('modal-open', 'open-sequence-edit-preview-modal');
    },

    openEmailBuilder() {
      if (this.localModel.email_id || this.localModel.content) {
        this.openBefreeBuilderSlider();
      } else {
        this.$root.$emit('modal-open', 'edit-sequence-email-templates-modal');
      }
    },

    async selectThisTemplate(templateId, templateType) {
      if (templateId) {
        this.emailTemplateId = templateId;
      }
      this.templateType = templateType || 'template';
      this.$root.$emit('modal-close', 'edit-sequence-email-templates-modal');
      this.openBefreeBuilderSlider();
    },

    initializeEmailContentData() {
      this.localModel.content = '';
      this.localModel.emailContentSections = '';
      this.localModel.email_id = null;
      this.localModel.template_name = '';
      this.localModel.template_folder = null;
    },


    // open confirmation chnage email type modal
    openEditorTypeConfirmation(newEmailType, oldEmailType) {
      // set new and old email type
      this.newEmailType = newEmailType;
      this.oldEmailType = oldEmailType;

      // open confirmation editor type
      this.$refs[`confirmation-editor-type`].open();
    },

    // confirm editor type chnage
    confirmEditorTypeChange() {
      this.localModel.editor_type = this.newEmailType;
      this.editorTypeChangedInternally = true;
      this.initializeEmailContentData();

      this.showEmailComposers = true;
    },

    // close confirmation editor type
    closeConfirmEditorTypeChange() {
      // reset new and old email type
      this.localModel.editor_type = this.oldEmailType;
      this.editorTypeChangedInternally = true;

      this.showEmailComposers = true;

      // reset new and old email type
      this.newEmailType = null;
      this.oldEmailType = null;
    },

    saveContentWithMeta(saveAs, emailJson, htmlData, emailTemplateMeta) {
      if (saveAs === 1 || saveAs === 3) {
        this.saveEmailContent(emailJson, htmlData, emailTemplateMeta, saveAs);
      } else if (saveAs === 2) {
        this.saveTemplateContent(emailJson, htmlData, emailTemplateMeta);
      }
    },

    async saveEmailContent(emailJson, htmlData, emailTemplateMeta, saveAs) {
      this.localModel.content = htmlData;
      this.localModel.emailContentSections = emailJson;
      if (emailTemplateMeta) {
        this.localModel.template_name = emailTemplateMeta.templateName;
        this.localModel.template_folder = emailTemplateMeta.templateFolder;
      }
      if (this.localModel.email_id) {
        try {
          this.showLoader();

          const emailPayload = this.fetchEmailPayload(emailJson, htmlData, emailTemplateMeta);
          await axios.put(`/email/template/${this.localModel.email_id}`, emailPayload);
          if (saveAs === 3) {
            this.closeBefreeBuilderSlider();
            this.template_id = null;
          }
          this.hideLoader();
        } catch (e) {
          this.requestErrorAlert(this.$t('frontend_groovemail_email_builder_templates_saving_retry'));
        }
      } else {
        try {
          this.showLoader();
          const emailPayload = this.fetchEmailPayload(emailJson, htmlData, emailTemplateMeta);
          const emailSaveRes = await axios.post(`/email/template/create`, emailPayload);
          this.localModel.email_id = emailSaveRes?.data?.id ? emailSaveRes?.data?.id : null;
          this.emailTemplateId = this.localModel.email_id;
          this.templateType = 'user-email';
          if (saveAs === 3) {
            this.closeBefreeBuilderSlider();
            this.template_id = null;
          }
          this.hideLoader();
        } catch (e) {
          this.requestErrorAlert(this.$t('frontend_groovemail_email_builder_templates_saving_retry'));
        }
      }
    },

    fetchEmailPayload(jsonData, htmlData, templateMeta) {
      return {
        message: htmlData,
        template_name: templateMeta.templateName,
        category_id: templateMeta.templateFolder,
        emailContentSections: jsonData,
        screenshot_image: templateMeta.screenshot ? templateMeta.screenshot : '',
      };
    },

    async saveTemplateContent(emailJson, htmlData, emailTemplateMeta) {
      if (emailTemplateMeta.templateId) {
        await this.updateTemplateContent(emailJson, htmlData, emailTemplateMeta);
      } else {
        await this.saveNewTemplateContent(emailJson, htmlData, emailTemplateMeta);
      }
    },

    fetchTemplatePayload(jsonData, htmlData, templateMeta) {
      return {
        template_name: templateMeta.templateName,
        category_id: templateMeta.templateFolder,
        emailContentSections: jsonData,
        message: htmlData,
        screenshot_image: templateMeta.screenshot ? templateMeta.screenshot : '',
      };
    },

    async saveNewTemplateContent(jsonData, htmlData, templateMeta) {
      try {
        this.showLoader();
        const templatePayload = this.fetchTemplatePayload(jsonData, htmlData, templateMeta);
        const templateSaveRes = await axios.post(`/user/template/create`, templatePayload);
        this.template_id = templateSaveRes?.data?.id ? templateSaveRes?.data?.id : null;
        this.hideLoader();
      } catch (e) {
        this.requestErrorAlert(this.$t('frontend_groovemail_email_builder_templates_saving_retry'));
      }
    },

    async updateTemplateContent(jsonData, htmlData, templateMeta) {
      try {
        this.showLoader();
        const templatePayload = this.fetchTemplatePayload(jsonData, htmlData, templateMeta);
        const templateSaveRes = await axios.put(`/user/template/${this.template_id}`, templatePayload);
        this.template_id = templateSaveRes?.data?.id ? templateSaveRes?.data?.id : null;
        this.hideLoader();
      } catch (e) {
        this.requestErrorAlert(this.$t('frontend_groovemail_email_builder_templates_saving_retry'));
      }
    },

    createNewSmsSender() {
      this.$emit('createNewSmsSender', 7);
    },

    async updateSmsSenderData(senderData) {
      this.showLoader();

      try {
        const fetchedSenders = await axios.get('/sms-sender');
        this.smsSenders = fetchedSenders.data;
        if (senderData && senderData.id) {
          this.localModel.sender_id = senderData.id;
        }
        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    createNewEmailSender() {
      this.$emit('createNewEmailSender', 7);
    },

    async updateEmailSenderData(senderData) {
      this.showLoader();

      try {
        await this.fetchsenders();
        if (!this.verifiedSendersRequired && senderData && senderData.id) {
          this.localModel.sender_id = senderData.id;
        }

        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    createNewList() {
      this.$emit('createNewList', 7);
    },

    async updateListData(lists) {
      this.showLoader();

      try {
        const mailLists = await axios.get(`/maillistonly`);
        this.lists = mailLists?.data?.data;
        if (lists && lists.data) {
          this.localModel.editassigned.push({
            name: lists.data.name,
            id: lists.data.id,
          });
        }

        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    createNewTag() {
      this.$emit('createNewTag', 7);
    },

    async updateTagData(tags) {
      this.showLoader();

      try {
        this.categories = await Category.$get();
        if (tags && tags.data) {
          this.localModel.editassigned.push({
            name: tags.data.name,
            id: tags.data.id,
          });
        }

        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    closeSmsVariables() {
      this.showSmsVariableDropdown = false;
    },

    openSmsVariables() {
      this.showSmsVariableDropdown = true;
    },

    closeSubjectVariables() {
      this.showSubjectDropdown = false;
    },

    openSubjectVariables() {
      this.showSubjectDropdown = true;
    },

    updateDynamicVariables(searchQuery) {
      if (searchQuery) {
        this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject.filter(
          (ele) => ele.label.toLowerCase().includes(searchQuery.toLowerCase())
        );
      } else {
        this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
      }
    },

    changedEmailSubjectSearchVariable(searchQuery) {
      this.updateDynamicVariables(searchQuery);
    },

    changedSmsSearchVariable(searchQuery) {
      this.updateDynamicVariables(searchQuery);
    },

    handleSmsTabChange(newTab) {
      this.currentSmsTab = newTab;
    },

    handleEmailTabChange(newTab) {
      this.currentEmailTab = newTab;
    },

    async fetchSendersData() {
      this.showLoader();

      try {
        const sendersData = await axios.get('/email-sms-sender');
        if (sendersData.data.admin_setting) {
          this.verifiedSendersRequired = true;
        } else {
          this.verifiedSendersRequired = false;
        }

        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    setSmsSender(senderId) {
      const sender = this.smsSenders.find((ele) => {
        return ele.id === senderId;
      });
      this.currentSmsSender = sender;
    },

    async fetchCustomFieldVariable() {
      this.showLoader();

      try {
        const customFieldsData = await axios.post('/customfield-variables');
        customFieldsData.data.forEach(fieldData => {
          this.dynamic_variables_sms_subject.push(fieldData);
          const mergeTagData = fieldData;
          mergeTagData.name = mergeTagData.label;
          this.builderVariables.push(mergeTagData);
        });

        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    editstep(option) {
      this.localModel.editmodulestep = option;
    },

    copyVariableInSubject(option) {
      if (!this.localModel.subject) {
        this.localModel.subject = '';
      }
      this.localModel.subject += `${option.value}`;
      this.showSubjectDropdown = false;
      this.emailSubjectVariableSearch = '';
      this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
    },

    // Set the variable in the content for the SMS
    copySmsVariable(option) {
      // target element to insert variable
      const content = document.getElementById('sms-text-area');

      let position;

      if (content && content.selectionStart != null && content.selectionStart !== undefined) {
        position = content.selectionStart;
      } else {
        this.localModel.smsContent += option;
      }

      this.localModel.smsContent = [
        this.localModel.smsContent.slice(0, position),
        option.value,
        this.localModel.smsContent.slice(position),
      ].join('');

      content.focus();

      content.setSelectionRange(
        position + option.value.length,
        position + option.value.length
      );

      this.showSmsVariableDropdown = false;
      this.smsVariableSearch = '';
      this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
    },

    validate() {
      if (
        this.localModel.edittype === 'email' &&
        (this.localModel.editor_type === 1 || this.localModel.editor_type === 2)
      ) {
        this.validateEmailContent();
      }
      this.$v.localModel.broadcast.$touch();
      this.$v.localModel.subject.$touch();
      this.isEmailContentSubmitted = true;
      if (this.localModel.edittype === 'email') {
        this.$v.localModel.content.$touch();
        if (
          !this.localModel.sender_id ||
          this.localModel.sender_id === -1 ||
          this.$v.localModel.broadcast.$invalid ||
          this.$v.localModel.subject.$invalid
        ) {
          this.currentEmailTab = 'settings';
        } else if (
          (
            (
              this.localModel.editor_type === 1 ||
              this.localModel.editor_type === 2
            ) &&
            this.$v.localModel.content.$invalid
          ) ||
          (
            this.localModel.editor_type === 3 &&
            (
              this.$v.localModel.content.$invalid ||
              !this.localModel.emailContentSections
            )
          )
        ) {
          this.currentEmailTab = 'message';
        }
        if (
          !this.$v.localModel.broadcast.$invalid &&
          !this.$v.localModel.subject.$invalid &&
          !this.$v.localModel.content.$invalid &&
          (
            this.localModel.editor_type === 1 ||
            this.localModel.editor_type === 2 ||
            this.localModel.emailContentSections
          )
        ) {
          return true;
        }
        return false;
      }
      if (this.localModel.edittype === 'sms') {
        this.$v.localModel.smsContent.$touch();
        if (
          !this.localModel.sender_id ||
          this.localModel.sender_id === '-1' ||
          this.$v.localModel.broadcast.$invalid
        ) {
          this.currentSmsTab = 'settings';
        } else if (this.$v.localModel.smsContent.$invalid) {
          this.currentSmsTab = 'message';
        }
        if (
          !this.$v.localModel.broadcast.$invalid &&
          !this.$v.localModel.smsContent.$invalid
        ) {
          return true;
        }
        return false;
      }
      return true;
    },

    inputHandler(eventData) {
      console.log(eventData);
    },

    dayshandler(option) {
      if (option.value === false) {
        if (
          this.localModel.editallowdays &&
          this.localModel.editallowdays.length
        ) {
          const index = this.localModel.editallowdays.indexOf(option.title);
          if (index > -1) {
            this.localModel.editallowdays.splice(index, 1);
          }
        }
      } else {
        this.localModel.editallowdays.push(option.title);
      }
    },

    async fetchsenders() {
      if (this.verifiedSendersRequired) {
        const { data } = await axios.get('/sender', {
          params: { verify: 1 },
        });
        if (data.length > 0) {
          this.senders = data;
        }
      } else {
        const { data } = await axios.get('/sender');
        if (data.length > 0) {
          this.senders = data;
        }
      }
      if (this.localModel.sender_id) {
        const sender = this.senders.find((ele) => {
          return ele.id === this.localModel.sender_id;
        });
        if (!sender) {
          this.localModel.sender_id = -1;
        }
      }
    },

    async fetchSmsSenders() {
      const integerationData = await axios.get('/sms-sender');
      if (
        integerationData &&
        integerationData.data &&
        integerationData.data.length
      ) {
        this.smsSenders = integerationData.data;
      }

      if (this.localModel.sender_id) {
        const sender = this.smsSenders.find((ele) => {
          return ele.id === this.localModel.sender_id;
        });
        if (!sender) {
          this.localModel.sender_id = -1;
        } else {
          this.currentSmsSender = sender;
        }
      }
    },

    getrecords() {
      if (this.model.edittype === 'tag') {
        this.localModel.editassigned.push({
          name: this.tagname,
          id: this.localModel.tag,
        });
        this.tags = [];
        this.localModel.tag = '';
      } else if (this.model.edittype === 'list') {
        this.localModel.editassigned.push({
          name: this.listname,
          id: this.localModel.list,
        });
        this.localModel.list = '';
      } else {
        this.localModel.editassigned.push(this.segmentname);
        this.localModel.segment = '';
      }

      this.addbtndisabled = true;
      this.localModel.editsavebtn = false;
    },

    deletemodule(option) {
      const index = this.localModel.editassigned.indexOf(option);
      this.localModel.editassigned.splice(index, 1);
    },

    async onChangecategory(e) {
      const { data } = await axios.get('/mailtag', {
        params: { category: e.target.value },
      });
      if (data.length > 0) {
        this.tags = data;
        this.tagdisabled = false;
      } else {
        this.tagdisabled = true;
      }
    },

    onChangelist(e) {
      this.localModel.savelistbtn = true;
      this.addbtndisabled = false;
      this.listname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
    },

    onChangetag(e) {
      this.localModel.savetagbtn = true;
      this.addbtndisabled = false;
      this.tagname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
    },

    onChangesegment(e) {
      this.localModel.savesegmentbtn = true;
      this.addbtndisabled = false;
      this.segmentname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
    },

    goToEditSection() {
      this.showSection.type = 2;
    },

    goToDetailSection() {
      this.showSection.type = 1;
    },

    updateModuleData() {
      this.$emit('updateModuleData');
    },

    changeSelect(e) {
      this.mainselectname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      if (this.localModel.edittype === 'split') {
        this.operation =
          this.mainselectname === 'Has tag' ||
          this.mainselectname === 'Subscribed to list'
            ? '='
            : '!=';
      }
    },

    changerecipient(e) {
      this.assignrecipientname = e.target.options[e.target.options.selectedIndex].dataset.name;

      this.localModel.editassigned.push({
        id: this.assignrecipient,
        name: this.assignrecipientname,
        type: this.mainselect,
        main: this.mainselectname,
      });
      this.tags = [];
      this.assignrecipient = '';
      this.assignrecipientname = '';
      this.mainselect = '';
      this.mainselectname = '';
    },

    changesplitrecipient(e) {
      this.assignrecipientname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.localModel.editassigned.push({
        id: this.assignrecipient,
        name: this.assignrecipientname,
        type: this.mainselect,
        main: this.mainselectname,
        operation: this.operation,
      });
      this.tags = [];
      this.assignrecipient = '';
      this.assignrecipientname = '';
      this.mainselect = '';
      this.mainselectname = '';
      this.operation = '';
    },

    async proceeedSendingTestEmail() {
      if (
        this.localModel.edittype === 'email' &&
        this.localModel.sender_id &&
        this.localModel.sender_id !== -1 &&
        !this.$v.localModel.subject.$invalid &&
        !this.$v.localModel.content.$invalid
      ) {
        await this.$refs.sendEditSeqTestMail.sendTestEmail(
          this.localModel.sender_id,
          this.localModel.subject,
          this.localModel.previewtext,
          this.localModel.content
        );
      } else if (!this.localModel.sender_id || this.localModel.sender_id === -1) {
        this.requestErrorAlert(this.$t('frontend_groovemail_send_test_email_sender_id_error'));
      } else if (this.$v.localModel.subject.$invalid) {
        this.requestErrorAlert(this.$t('frontend_groovemail_send_test_email_subject_error'));
      } else if (this.$v.localModel.content.$invalid) {
        this.requestErrorAlert(this.$t('frontend_groovemail_send_test_email_content_error'));
      } else {
        this.requestErrorAlert(this.$t('frontend_error'));
      }
    },

    onPostalCampaignChange(e) {
      this.localModel.postalCampaign =
        e.target.options[e.target.options.selectedIndex].dataset.name;
    },

		async fetchPostalCampaigns() {
      // show loader
      this.showLoader();

      try {
        const postalCampaigns = await axios.get('/postal/broadcast');
        if (postalCampaigns.data.status.toLowerCase() === 'fail') {
          this.requestErrorAlert(this.$t('frontend_groovemail_campaigns_create_postal_integration_invalid'));
          this.postalCampaigns = [];
        } else if (
          postalCampaigns &&
          postalCampaigns.data &&
					postalCampaigns.data.response &&
					postalCampaigns.data.response.campaigns &&
					postalCampaigns.data.response.campaigns.length
        ) {
          this.postalCampaigns = postalCampaigns.data.response.campaigns;
        }

        // hide loader
        this.hideLoader();
      } catch (error) {
				// show error message
        this.requestErrorAlert(error.response?.data?.error);
        this.postalCampaigns = [];
      }
    },

    redirectToCLosemDashboard() {
      window.open('https://app.closem.ai/index.php?m=campaigns');
    },

    redirectToCLosemSignupPage() {
      const user = auth.authenticatedUser();
      window.open(`${'https://groove.closem.ai/?fpr=groove'}&name=${user.name}&email=${user.email}&phone=`);
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();

      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },
  },

  computed: {
    //  Can mail/Upgraded user/Sandbox mode check
    userCanMail() {
      return this.getCanMail();
    },
    //  Can mail/Upgraded user/Sandbox mode check

    flowSetting() {
      return [
        {
          id: 1,
          name: this.$t('frontend_groovemail_sequence_goto_flow_pause_option'),
        },
        {
          id: 2,
          name: this.$t(
            'frontend_groovemail_sequence_goto_flow_dont_pause_option'
          ),
        },
      ];
    },

    timeoptions() {
      return [
        {
          id: 1,
          title: this.$t(
            'frontend_groovemail_sequence_delay_time_option_anytime_day'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_time_option_anytime_day'
          ),
          checked: this.model.editallowtime === 1,
        },
        {
          id: 2,
          title: this.$t(
            'frontend_groovemail_sequence_delay_time_option_between'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_time_option_between'
          ),
          checked: this.model.editallowtime === 2,
        },
      ];
    },

    daysoptions() {
      return [
        {
          id: 1,
          title: this.$t('frontend_groovemail_monday_long'),
          placeholder: this.$t('frontend_groovemail_monday_long'),
          value: !!(
            this.model.editallowdays &&
            this.model.editallowdays.length &&
            this.model.editallowdays.includes('Monday')
          ),
        },
        {
          id: 2,
          title: this.$t('frontend_groovemail_tuesday_long'),
          placeholder: this.$t('frontend_groovemail_tuesday_long'),
          value: !!(
            this.model.editallowdays &&
            this.model.editallowdays.length &&
            this.model.editallowdays.includes('Tuesday')
          ),
        },
        {
          id: 3,
          title: this.$t('frontend_groovemail_wednesday_long'),
          placeholder: this.$t('frontend_groovemail_wednesday_long'),
          value: !!(
            this.model.editallowdays &&
            this.model.editallowdays.length &&
            this.model.editallowdays.includes('Wednesday')
          ),
        },
        {
          id: 4,
          title: this.$t('frontend_groovemail_thursday_long'),
          placeholder: this.$t('frontend_groovemail_thursday_long'),
          value: !!(
            this.model.editallowdays &&
            this.model.editallowdays.length &&
            this.model.editallowdays.includes('Thursday')
          ),
        },
        {
          id: 5,
          title: this.$t('frontend_groovemail_friday_long'),
          placeholder: this.$t('frontend_groovemail_friday_long'),
          value: !!(
            this.model.editallowdays &&
            this.model.editallowdays.length &&
            this.model.editallowdays.includes('Friday')
          ),
        },
        {
          id: 6,
          title: this.$t('frontend_groovemail_saturday_long'),
          placeholder: this.$t('frontend_groovemail_saturday_long'),
          value: !!(
            this.model.editallowdays &&
            this.model.editallowdays.length &&
            this.model.editallowdays.includes('Saturday')
          ),
        },
        {
          id: 7,
          title: this.$t('frontend_groovemail_sunday_long'),
          placeholder: this.$t('frontend_groovemail_sunday_long'),
          value: !!(
            this.model.editallowdays &&
            this.model.editallowdays.length &&
            this.model.editallowdays.includes('Sunday')
          ),
        },
      ];
    },

    stepoptions() {
      return [
        {
          id: 1,
          title: this.$t('frontend_groovemail_sequences_showdetail_right'),
          placeholder: this.$t(
            'frontend_groovemail_sequences_showdetail_right'
          ),
        },
        {
          id: 2,
          title: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_days'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_days'
          ),
        },
        {
          id: 3,
          title: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_date'
          ),
          placeholder: this.$t(
            'frontend_groovemail_sequence_delay_step_option_wait_date'
          ),
        },
      ];
    },

    tabs() {
      return [
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_user_index_settings'
          )}</span>`,
          value: 'settings',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_sequences_edit_message'
          )}</span>`,
          value: 'message',
        },
      ];
    },

    mainTabClass: () => 'pb-4 gs-default-tabs-item',

    getEmailMetaData() {
      return {
        emailId: this.localModel.email_id,
        templateName: this.localModel.template_name,
        templateFolder: this.localModel.template_folder,
      };
    },

    email_type_options() {
      return [
        {
          id: 3,
          title: this.$t(
            'frontend_groovemail_email_type_email_builder_text'
          ),
          description: this.$t(
            'frontend_groovemail_email_type_email_builder_description'
          ),
          placeholder: '',
        },
        {
          id: 1,
          title: this.$t(
            'frontend_groovemail_email_type_basic_editor_text'
          ),
          description: this.$t(
            'frontend_groovemail_email_type_basic_editor_description'
          ),
          placeholder: '',
        },
        {
          id: 2,
          title: this.$t(
            'frontend_groovemail_email_type_html_paste_text'
          ),
          description: this.$t(
            'frontend_groovemail_email_type_html_paste_description'
          ),
          placeholder: '',
        },
      ];
    },
  },

  components: {
    DelayNode,
    VuePerfectScrollbar,
    InfoIcon,
    EmailBuilder,
    TemplateContainer,
    SlideOver,
    EmailBasicEditor,
    SendTestEmail,
    PreviewIcon,
    PlusIcon,
    DownIcon,
    SearchIcon,
  },
};
</script>

<style scoped>
.gm-edit-detail-assignments select {
  width: 100%;
  min-height: 2.75rem;
  color: var(--gs-foreground);
  border-color: var(--gs-border);
  background: var(--gs-input);
}

.gm-edit-detail-assignments select:focus-visible,
.gm-edit-detail-assignments__create:focus-visible,
.gm-edit-detail-assignments .list-chip:focus-within {
  outline: 2px solid var(--gs-primary);
  outline-offset: 2px;
  box-shadow: var(--gs-active-shadow);
}

.gm-edit-detail-assignments__create {
  display: inline-flex;
  width: fit-content;
  min-height: 2.75rem;
  align-items: center;
  color: var(--gs-primary);
}

.gm-edit-detail-assignments .list-chip {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-height: 2.75rem;
  margin: 0.5rem 0 0;
  align-items: center;
  justify-content: space-between;
  color: var(--gs-foreground);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  background: var(--gs-surface-subtle);
}

.gm-edit-detail-assignments .list-chip > span:first-child {
  min-width: 0;
  flex: 1 1 auto;
  overflow-wrap: anywhere;
}

.gm-edit-detail-assignments .list-chip > span:last-child {
  display: inline-flex;
  min-width: 2.75rem;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  color: var(--gs-danger);
  cursor: pointer;
}

.gm-edit-detail-assignments .list-chip > span:last-child:hover {
  color: var(--gs-danger);
  background: var(--gs-surface);
}
</style>
